import { differenceInMilliseconds } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export const dynamicCountdown = (start_at, end_at, rsvp_deadline_date) => {
  if (!start_at || !end_at) return null;

  const TIMEZONE = '+08:00';
  const now = utcToZonedTime(new Date(), TIMEZONE);
  const startDate = utcToZonedTime(new Date(start_at), TIMEZONE);
  const endDate = utcToZonedTime(new Date(end_at), TIMEZONE);

  const calculateTime = (targetDate) => {
    const remainingMs = differenceInMilliseconds(targetDate, now);
    const totalHours = remainingMs / (1000 * 60 * 60);
    const days = remainingMs > 0 ? Math.floor(remainingMs / (1000 * 60 * 60 * 24)) : 0;
    const hours = remainingMs > 0 ? Math.floor((remainingMs / (1000 * 60 * 60)) % 24) : 0;
    const minutes = remainingMs > 0 ? Math.floor((remainingMs / 1000 / 60) % 60) : 0;
    return { totalHours, days, hours, minutes };
  };

  const { totalHours: hoursToStart, days: startDays, hours: startHours, minutes: startMins } = calculateTime(startDate);
  
  const isHappeningNow = hoursToStart <= 0 && (now.getTime() >= startDate.getTime() && now.getTime() <= endDate.getTime());

  // 1. Without rsvp_deadline_date
  if (!rsvp_deadline_date) {
    if (hoursToStart > 72) return null; 
    if (hoursToStart >= 0 && hoursToStart <= 72) {
      return { status: 'rsvp_closed', days: startDays, hours: startHours, minutes: startMins };
    }
    if (isHappeningNow) {
      return { status: 'happening_now', days: 0, hours: 0, minutes: 0 };
    }
    return null; 
  }

  // 2. With rsvp_deadline_date
  const deadlineDate = utcToZonedTime(new Date(rsvp_deadline_date), TIMEZONE);
  const { totalHours: hoursToDeadline, days: dlDays, hours: dlHours, minutes: dlMins } = calculateTime(deadlineDate);

  if (hoursToDeadline > 72) return null;
  
  if (hoursToDeadline >= 0 && hoursToDeadline <= 72) {
    return { status: 'rsvp_open', days: dlDays, hours: dlHours, minutes: dlMins };
  }
  
  if (hoursToDeadline <= 0) {
    if (hoursToStart >= 0 && hoursToStart <= 72) {
      return { status: 'rsvp_closed', days: startDays, hours: startHours, minutes: startMins };
    }
    if (isHappeningNow) {
      return { status: 'happening_now', days: 0, hours: 0, minutes: 0 }; 
    }
  }

  return null;
};
